module.exports = __webpack_public_path__ + "media/dashboard/assets/images/assistents/research-d32ff644b87ad3e8338f8b1ab51fd2b6.png";